<template>
    <div>
        <p>Sign-in in progress</p>
    </div>
</template>

<script>
    export default {
        async created() {
            try {
                this.$auth.handleLoginRedirect()
                    .then((result) => {
                        var returnUrl = result.state === '/index.html' ? '/' : result.state; 
                        this.$router.push({ path: returnUrl });
                    });
            } catch (e) {
                this.$router.push({ name: '/' });
            }
        }
    }
</script>